export function isSet(value?: string) {
    if (typeof value !== "string") return false;
    return ![null, undefined, ''].includes(value?.trim());
}

export function notSet(value?: string) {
    return !isSet(value);
}
export function withFallback(value: string | undefined, fallback: string): string {
    return isSet(value) ? value!.trim() : fallback;
}
